<cds-modal
    size="lg"
    (closeChange)="close()"
    class="certificate-chain-dialog clr-wrapper"
>
    <cds-modal-header>
        <h3>{{ l10nKeys.certificateChainTitle | vtranslate }}</h3>
    </cds-modal-header>

    <cds-modal-content>
        <div class="certificate-chain-dialog__content">
            <!-- Reusable item template -->
            <ng-template
                #itemTemplate
                let-item
                let-level="level"
            >
                <div 
                    class="certificate-chain-dialog__item" 
                    [style.margin-left]="getIndentationWidth(level)"
                >
                    <div class="certificate-chain-dialog__item-content">
                        <div 
                            *ngIf="item.hasChildren"
                            class="certificate-chain-dialog__icon"
                        >
                            <cds-icon
                                status="info"
                                solid="true"
                                direction="down"
                                shape="angle"
                            ></cds-icon>
                        </div>
                        <span class="certificate-chain-dialog__name">{{ item.name }}</span>
                    </div>
                </div>
            </ng-template>

            <!-- Root Certificate -->
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: rootItem, level: 0 }"></ng-container>
            
            <!-- Certificate Chain Items -->
            <div class="certificate-chain-dialog__children">
                <ng-container 
                    *ngFor="let item of chainItems"
                    [ngTemplateOutlet]="itemTemplate"
                    [ngTemplateOutletContext]="{ $implicit: item, level: item.level }"
                ></ng-container>
            </div>
        </div>
    </cds-modal-content>

    <cds-modal-actions>
        <cds-button
            status="primary"
            (click)="close()"
        >
            {{ l10nKeys.closeButtonLabel | vtranslate }}
        </cds-button>
    </cds-modal-actions>
</cds-modal>
